import { Layer, Source } from 'react-map-gl';
import { COLOR_BACKGROUND_ACCENT } from '@alltrails/denali/tokens';
import useSvgImages from '../../utils/useSvgImages';
import { distanceAwayCenterMarkerId, defaultSymbolLayerLayoutProps, getLayerBeforeId } from '../../utils/layers';
import useMap from '../../hooks/useMap';
import { createTargetMarker } from '../../utils/svgDefinitions/svgMarkerComponents';

const sourceId = 'distance-away-center-marker';
const svgDefinitions = [createTargetMarker(distanceAwayCenterMarkerId, COLOR_BACKGROUND_ACCENT)];

type DistaneAwayCenterMarkerProps = {
  latitude: number;
  longitude: number;
};

const DistaneAwayCenterMarker = ({ latitude, longitude }: DistaneAwayCenterMarkerProps) => {
  const map = useMap();
  const { imagesAreLoaded } = useSvgImages(svgDefinitions);

  if (!imagesAreLoaded) {
    return null;
  }

  return (
    <Source
      id={sourceId}
      type="geojson"
      data={{
        type: 'Point',
        coordinates: [longitude, latitude]
      }}
    >
      <Layer
        id={distanceAwayCenterMarkerId}
        source={sourceId}
        beforeId={getLayerBeforeId(map, distanceAwayCenterMarkerId)}
        type="symbol"
        layout={{
          ...defaultSymbolLayerLayoutProps,
          'icon-allow-overlap': true, // Always want this to show up
          'icon-image': distanceAwayCenterMarkerId
        }}
      />
    </Source>
  );
};

export default DistaneAwayCenterMarker;
